
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-training-calander',
  templateUrl: './training-calander.component.html',
  styleUrl: './training-calander.component.scss'
})
export class TrainingCalanderComponent implements OnInit , OnChanges{
  daysOfWeek: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  calendarData: any[] = [];
  currentDate: Date = new Date();
  apiData : any = []
  modalData : any
  showDilogue  = false
  @Input() training_type !: string 
  @Input() userProfileFlag !: boolean 
  @Input() query !:any
  

  @Output() showTraining: EventEmitter<any> = new EventEmitter();

  constructor(private dataService: DataService,private router: Router,) { }

  ngOnInit(): void {
    this.getData().then(()=>{
      this.generateCalendarDays();
    })
  }


  ngOnChanges() {
    this.getData().then(()=>{
      this.generateCalendarDays();
    })
  }


  showTrainingDetail(req:any){
    this.showTraining.emit(req);
    let params = {
      _id : req.trainingId,
      flag : 'VIEW', 
      from : this.userProfileFlag ? 'Attendee' : 'SBC' 
    }
    this.navigateToTrainingPage(params)
  }

  navigateToTrainingPage(params:any) {
    const trainingId = params._id;
    this.router.navigate(['/training/training-page', trainingId], { queryParams: params } );
  }

  generateCalendarDays(): void {
    const currentMonth = this.currentDate.getMonth();
    const currentYear = this.currentDate.getFullYear();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  
    this.daysOfWeek = this.daysOfWeek.slice(this.daysOfWeek.indexOf('Sunday')).concat(this.daysOfWeek.slice(0, this.daysOfWeek.indexOf('Sunday')));
  
    const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
    const startingDay = (firstDayOfMonth - this.daysOfWeek.indexOf('Sunday') + 7) % 7;
  
    this.calendarData = [];
  
    let currentRow: any[] = [];
    for (let day = 1; day <= daysInMonth + startingDay; day++) {
      const dayNumber = day - startingDay;
  
      const dateKey = `${currentYear}-${currentMonth + 1}-${dayNumber}`;
  
      const dayData = this.apiData.find((data:any) => {
        return data._id.year === currentYear && data._id.month === currentMonth + 1 && data._id.day === dayNumber;
      });
  
      currentRow.push({
        _id: { year: currentYear, month: currentMonth + 1, day: dayNumber },
        data: dayData ? dayData.data : []
      });
  
      if (currentRow.length === 7) {
        this.calendarData.push(currentRow);
        currentRow = [];
      }
    }
  
    // Add the last row if it's not complete
    if (currentRow.length > 0) {
      this.calendarData.push(currentRow);
    }
  }

  formatMonth(): string {
    return this.currentDate.toLocaleDateString('en-US', { month: 'long' });
  }

  formatYear(): string {
    return this.currentDate.toLocaleDateString('en-US', { year: 'numeric' });
  }

  nextMonth(): void {
    this.currentDate.setMonth(this.currentDate.getMonth() + 1);
    this.getData().then(()=>{
      this.generateCalendarDays();
    })
  }

  prevMonth(): void {
    this.currentDate.setMonth(this.currentDate.getMonth() - 1);
    this.getData().then(()=>{
      this.generateCalendarDays();
    })
  }

  async getData(){
    try {

      

      let currentDate = this.currentDate
      currentDate.setDate(1)
      currentDate.setHours(0,0,0,0)
      const lastDayOfMonth = this.getLastDayOfMonth(this.currentDate);
      lastDayOfMonth.setHours(0,0,0,0);

      let query : any = {
        start_date : currentDate,
        end_date : lastDayOfMonth,
        type : this.training_type == 'MONTHLY' ? 'Unified session' : this.training_type
      }

      if(this.query || this.query != null){
        query = {...query , ...this.query}
      }


      let url = 'training-req/get/calender'
      if(this.userProfileFlag){
        url = 'course/training-calender'
        query.uid = localStorage.getItem('uid')
      }

      let res = await this.dataService.postData(url, query);

      if(res.error) return;
      this.apiData = res.data;


      // 
    } catch (error) {
      console.log(error)
    }
  }

  getLastDayOfMonth(date: Date): Date {
    // Create a new date based on the input date
    const lastDay = new Date(date);
  
    // Set the date to the last day of the month
    lastDay.setMonth(lastDay.getMonth() + 1, 0);
  
    return lastDay;
  }

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  openTraining(id:any){
    //emmiter 
  }

  getModalData(modalData:any){
    this.modalData = modalData
    
    if(modalData.data.length <=0) return
    this.showDilogue= true
      modalData?.data?.forEach((item: any) => {
        if (item.request_id.status = 'COMPLETED') {
          let allsessions = item.session.filter((e: any) => !e.sessionId?.video_url)
          let value = this.calculateAttendancePercentage(allsessions)

          if (this.calculateAttendancePercentage(allsessions) < 70) {
            item.request_id.status = 'ATTENDANCE_SHORT'
            // this.cardData.splice(this.cardData.indexOf(item._id), 1);
          }
        }
      });

      this.modalData
      

  }

  calculateAttendancePercentage(sessions: any) {

    let uid = localStorage.getItem('uid');

    // Filter sessions where the attendee is present
    const attendedSessions = sessions.filter((session: any) => session?.attendees?.includes(uid));

    // Calculate total sessions and attended sessions count
    const totalSessions = sessions.length;
    const attendedSessionsCount = attendedSessions.length;

    // Calculate attendance percentage
    const attendancePercentage = (attendedSessionsCount / totalSessions) * 100;

    return attendancePercentage;
  }

}
